import styled from 'styled-components';

export const PaginationStepWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PaginationStepSelectWrapper = styled.div`
  width: 72px;
  margin-left: 16px;
  text-align: center;
  position: relative;

  .Select-control {
    z-index: 9 !important;
  }

  .Select-value-label {
    padding-left: 12px;
  }

  .prefix {
    font-size: 12px;
    position: absolute;
    top: 8px;
    left: 10px;
    z-index: 10;
    pointer-events: none;
  }

  @media (max-width: 512px) {
    margin-left: 0;
  }
`;

export const PaginationStepHeader = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};
  color: ${({ theme }) => theme.colors.limedSpruce};
  line-height: 1.5;
  letter-spacing: -0.1px;
  white-space: nowrap;
`;
